// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_u9-0";
export var checkoutRateBadgeLink = "_u9-1";